import React from 'react';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
// import MainLogo from 'utils/icon/PI-ER logo.png';
import MainLogo from 'utils/icon/carpe_white.svg';
import collpase from 'utils/icon/collpase.svg';
/**
 * * 사이드바 - 상단 로고
 */

interface IProps {
  collapsed?: string;
  handleCollapse?: (e: React.MouseEvent) => void;
}

const SidebarLogo = ({ collapsed, handleCollapse }) => {
  const [cookies] = useCookies();
  const navigate = useNavigate();

  const goMain = () => {
    navigate('/');
  };

  return (
    <SideHeader collapsed={cookies?.collapsed}>
      <CollpaseBtn src={collpase} alt='collpase' onClick={handleCollapse} />
      {collapsed ? <></> : <LogoImg src={MainLogo} alt='logo' />}
    </SideHeader>
  );
};

export default SidebarLogo;
const SideHeader = styled.div<IProps>`
  margin: ${(props) => (props.collapsed === 'true' ? '14px 0' : '7px 0')};
`;
const CollpaseBtn = styled.img<IProps>`
  width: 20px !important;
  height: 20px !important;
  cursor: pointer;
  margin-top: 15px;
  margin-left: 30px;
`;
const LogoImg = styled.img`
  width: 94px !important;
  height: 61px !important;
  object-fit: contain;
  margin-top: 0 !important;
  margin-left: 2rem;
`;
